import React from 'react';
import {
  calculatePriceAfterDiscount,
  formatDecimalNumber,
  getFinalProductPrice,
} from '../../config_and_helpers/helpers';
import { getCurrencySymbol } from '../../config_and_helpers/helpers';

/**
 * Generate a discounted price component for a given product.
 *
 * @param {object} options - The options object containing the necessary parameters.
 * @param {object} options.product - The product to be displayed.
 * @param {object} options.currencyRates - The currency rates used for conversion.
 * @param {boolean} [options.convertCurrency=false] - Indicates whether to convert the currency or not.
 * @param {number} options.discountedPricePerUnit - The discounted price per unit.
 *
 * @return {JSX.Element|null} The JSX element representing the discounted price component, or null if any of the required parameters is missing.
 */
const DiscountedPriceComponent = ({
  product,
  currencyRates,
  convertCurrency = false,
  discountedPricePerUnit,
}) => {
  return (
    <>
      {product && (
        <div>
          <span>
            Discounted Price:{' '}
            {convertCurrency
              ? getFinalProductPrice(product, currencyRates, true)
              : formatDecimalNumber(
                  calculatePriceAfterDiscount(product.price, product.discount)
                )}
            {getCurrencySymbol(product.currency)}
          </span>
          {discountedPricePerUnit && (
            <span>
              , {discountedPricePerUnit}
              {getCurrencySymbol(product.currency)} per {product.unit}
            </span>
          )}
        </div>
      )}
    </>
  );
};
export default DiscountedPriceComponent;
